import React from "react";
import { IoIosUndo, IoIosRedo } from "react-icons/io";
import MessageContent from "./component/MessageContent";
import MessageStatus from "./component/MessageStatus";
import { formatTime } from "src/utils/DateTimeFormatter";


function MessageBubble({ message, onReply, onInteractiveClick }) {
  const outgoing = message?.direction === "Outgoing";
  const type = String(message?.type || "").toLowerCase();

 return (
  <div className={`wa-msg-row group ${outgoing ? "is-out" : "is-in"}`}>
    {/* =====================================================
        REPLY - OUTGOING
    ====================================================== */}
    {outgoing && (
      <ReplyButton
        onClick={() => onReply?.(message)}
        icon={<IoIosUndo size={15} />}
        title="Reply"
      />
    )}

    {/* AUTO-WA-39: Stage bubble — brand-blue tint for you, white for the customer. */}
    <div className={`wa-bubble-msg ${outgoing ? "is-out" : "is-in"} ${type === "text" ? "is-text" : "is-media"}`}>
      <div className="wa-bubble-msg-body">
        <MessageContent
          message={message}
          onInteractiveClick={onInteractiveClick}
        />
      </div>
      <div className="wa-bubble-msg-time">
        <span>{formatTime(message?.meta_timestamp ?? message?.created_at)}</span>
        <MessageStatus message={message} />
      </div>
    </div>

    {/* =====================================================
        REPLY - INCOMING
    ====================================================== */}
    {!outgoing && (
      <ReplyButton
        onClick={() => onReply?.(message)}
        icon={<IoIosRedo size={15} />}
        title="Reply"
      />
    )}
  </div>
);
}

function ReplyButton({ onClick, icon, title }) {
return (
  <button
    type="button"
    onClick={onClick}
    className="wa-msg-reply"
    aria-label={title}
    title={title}
  >
    {icon}
  </button>
);
}

export default MessageBubble;
